import React, { useState } from 'react';
import { viewport } from '../../utils/utils';
import Row from '../ResponsiveRow/row';
import { Carousel } from 'react-bootstrap';
import styles from './DpLinetableContainer.module.scss';
import DpTabContainer from './DpTabContainer';

const DpLinetableContainer = ({ content, metadata, isProdEnv }: any) => {
  const viewPort = viewport();
  const [index, setIndex] = useState(0);

  return (
    <>
      {viewPort && (
        <Row resuablelineTable={true}>
          <div className={styles.linetableContainer}>
            {/* Tab buttons */}
            {content?.tabContainer?.length > 0 && (
              <div className={styles.tabsLabelContainer}>
                {(content?.tabContainer || []).map((product: any, i: number) => {
                  return (
                    <>
                      {product?.tabTitle && (
                        <button
                          key={i}
                          onClick={() => setIndex(i)}
                          className={`${styles.tabsButton} ${index === i && styles.activeTab}`}
                        >
                          {product?.tabTitle}
                        </button>
                      )}
                    </>
                  );
                })}
              </div>
            )}
            {/* Tab carousel section */}
            {content?.tabContainer?.length > 0 && (
              <div className={`${'position-relative'} `}>
                <Carousel
                  activeIndex={index}
                  indicators={false}
                  controls={false}
                  interval={null}
                  id='pt-carousel'
                  slide={false}
                >
                  {(content?.tabContainer || [])?.map((tabData: any, i: number) => {
                    return (
                      <Carousel.Item key={i} className={styles.item}>
                        <DpTabContainer
                          tabData={tabData}
                          tabIndex={i} // tab index
                          mainContent={content} //whole content
                          activeTab={index} //index of active tab
                          metadata={metadata}
                          isProdEnv={isProdEnv}
                        />
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              </div>
            )}
          </div>
        </Row>
      )}
    </>
  );
};

export default DpLinetableContainer;
